<template>
</template>

<script>
export default {
  name: 'fabricShow',
  created () {
    this.$router.push(this.$route.fullPath.replace('fabricShow', 'wap/show'))
  }
}
</script>



// WEBPACK FOOTER //
// fabricShow.vue?757b6d2d